import Select from "../Select/Select";
import { DataIntegritySource } from "../../../types/types";

// Also include a simple little colour splodge. This doesn't match up exactly with the actual colours in the data table,
// but this should keep it nice and simple.
const options = [
	{ key: 5, value: 5, text: "Supplied", label: { color: "grey", empty: true, circular: true } },
	{ key: 4, value: 4, text: "EPC", label: { color: "violet", empty: true, circular: true } },
	{ key: 3, value: 3, text: "Cloned", label: { color: "orange", empty: true, circular: true } },
	{ key: 1, value: 1, text: "Assumed", label: { color: "red", empty: true, circular: true } },
	{ key: 2, value: 2, text: "Confirmed/XML", label: { color: "green", empty: true, circular: true } },
	{ key: 6, value: 6, text: "API", label: { color: "green", empty: true, circular: true } },
];

interface DataIntegrityDropdownProps {
	value: DataIntegritySource | undefined;
	onChange: (value: DataIntegritySource | undefined) => void;
	disabled?: boolean;
}

export default function DataIntegrityDropdown({ value, onChange, disabled }: DataIntegrityDropdownProps) {
	return (
		<Select
			placeholder="Integrity"
			options={options}
			value={value}
			disabled={disabled}
			clearable
			onChange={(_, data) => onChange((data.value as DataIntegritySource) || undefined)}
		/>
	);
}
